import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const TestResultsCard = () => {
  const theme = useTheme();

  return (
    <DashboardCard
      title="Test Results"
      description="Displays the passing, failing and not run counts of the selected tests"
      icon={fas.faVial}
    >
      {(data) => (
        <Box sx={{ display: 'flex', gap: 3 }}>
          <TestCount value={data.tests.pass} label="Passing" icon={fas.faCheck} color={theme.palette.success.main} />
          <TestCount value={data.tests.fail} label="Failing" icon={fas.faXmark} color={theme.palette.error.main} />
          <TestCount
            value={data.tests.notRun}
            label="Not Run"
            icon={fas.faMinus}
            color={theme.palette.text.secondary}
          />
        </Box>
      )}
    </DashboardCard>
  );
};

const TestCount = ({ value, label, icon, color }) => (
  <Box sx={{ flex: 1 }}>
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 0.5 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color }}>
        {value}
      </Typography>
      <FontAwesomeIcon icon={icon} style={{ fontSize: 14, color }} />
    </Box>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Box>
);
